import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import KolmogorovMachinePage from './routes/projects/kolmogorov-machines'
import './styles.css'
import './routes/projects/kolmogorov-machines/kolmogorov-machines.css'

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root')

createRoot(root).render(
  <StrictMode>
    <KolmogorovMachinePage />
  </StrictMode>,
)
